import React from 'react';
import { useDispatch, useSelector } from 'react-redux'

const TaskQueue = props => {
    const queue = useSelector(state => state.db.present.taskQueue)
    const taskIndex = useSelector(state => state.db.present.taskIndex) // Index that is ready to run
    const [currentIndex, setIndex] = React.useState(null) // Index that has been run

    React.useEffect(() => {
        // console.log({currentIndex, taskIndex, check: taskIndex !== currentIndex})
        if(taskIndex !== currentIndex){
            run()
            taskIndex < queue.length && setIndex(taskIndex) // Don't increase currentIndex unless that is a task queue to run at the new index
        }
    })

    const run = async() => {
        if(queue.length > 0 && taskIndex < queue.length){
            new Promise(queue[taskIndex])
        }
    }
    
    return (<div></div>)
}

export default TaskQueue